import type React from 'react';
import { useMemo } from 'react';
import { Drawer } from '../Drawer';
import { RulesManagerContent } from './RulesManagerContent';
import {
  RulesManagerContext,
  type RulesManagerContextProps,
} from './RulesManagerContext';
import { RulesManagerEmptyState } from './RulesManagerEmptyState';
import { RulesManagerHeader } from './RulesManagerHeader';
import { RulesManagerSubheader } from './RulesManagerSubheader';

export interface RulesManagerProps extends RulesManagerContextProps {
  isOpen?: boolean;
  onClose?: () => void;
  children?: React.ReactNode;
  detailsContent?: React.ReactNode;
  onCloseDetails?: () => void;
}

export const RulesManager = ({
  isOpen,
  onClose,
  onLearnMoreClick,
  children,
  detailsContent,
  onCloseDetails,
}: RulesManagerProps) => {
  const contextValue = useMemo(
    () => ({ onLearnMoreClick }),
    [onLearnMoreClick]
  );

  return (
    <RulesManagerContext.Provider value={contextValue}>
      <Drawer
        open={isOpen}
        width={324}
        maxWidth={700}
        side="left"
        onClickOutside={onClose}
        detailsContent={detailsContent}
        onCloseDetails={onCloseDetails}
      >
        <div
          className="flex flex-col p-4 h-full w-full"
          role="dialog"
          aria-labelledby="rules-manager-header"
        >
          {children}
        </div>
      </Drawer>
    </RulesManagerContext.Provider>
  );
};

RulesManager.Header = RulesManagerHeader;
RulesManager.Subheader = RulesManagerSubheader;
RulesManager.Content = RulesManagerContent;
RulesManager.EmptyState = RulesManagerEmptyState;
